import React from 'react';
import request from 'arcdynamic-request';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import { TEAM } from '../../consts/tables';
import { getData } from '../../requests/CRUD';

class SelectTeamMember extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
        };
    }

    componentDidMount() {
         getData({
            tableCode: TEAM,
            options: {
                limit: {
                    count: 1000,
                    offset: 0,
                },
                column: [
                    'ARCIMEDES_ROW_ID',
                    'FIRST_NAME',
                    'LAST_NAME',
                    'DELETED',
                    'IS_AGENT',
                ],
                filter: [
                    {
                        code: 'FIRST_NAME',
                        text: '',
                        type: 'notNull',
                    },
                    {
                        code: 'LAST_NAME',
                        text: '',
                        type: 'notNull',
                    },
                ],
                filterType: 'and',
                order: [
                    {
                        code: 'FIRST_NAME',
                        type: 'asc',
                    },
                    {
                        code: 'LAST_NAME',
                        type: 'asc',
                    },
                ],
            },
        }).then(res => {
            let items = res.data ? res.data.filter(x => x.FIRST_NAME && x.LAST_NAME) : false;           
            this.setState({items});
        }); 
    }

    render() {
        const {
            theme,
            value,
            valueKey,
            percentKey,
            label,
            percentLabel,
            disabled,
            data,
            isFilter,
            handleParentChange,
            handleInputParentChange,
            viewMode,
            deleted,
            isFromProperty,
            hasAgentPercent,
            ...rest
        } = this.props;
        const { items } = this.state;
        const teamMemberList = items && items.filter(x => (x.DELETED === 'n' || x.DELETED === null)) || [];
  
        return (
            <Dropdown theme={theme}
                      optionsType='team'
                      optionKey='ARCIMEDES_ROW_ID'
                      options={teamMemberList}
                      value={value}
                      valueKey={valueKey}
                      percentKey={percentKey}
                      label={label}
                      percentLabel={percentLabel}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      groupBy={true && !this.props.onlyActive}
                      handleParentChange={handleParentChange}
                      handleInputParentChange={handleInputParentChange}
                      viewMode={viewMode}
                      deleted={deleted}
                      isFromProperty={isFromProperty}
                      hasAgentPercent={hasAgentPercent}
                      {...rest}
            />
        )
    }
}

SelectTeamMember.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    percentLabel: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    groupBy: PropTypes.bool,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    hasAgentPercent: PropTypes.bool,
    handleInputParentChange: PropTypes.func,
};

export default SelectTeamMember;
